module.exports = __webpack_public_path__ + "static/media/cl.6d63ff70.svg";